<nav id="menu-support" (keyup.escape)="close()" aria-label="Support Menu">
    <div id="support-header">
        <i class="fa-regular fa-comment-question" [style.color]="'#fff'"></i>

        <p>{{ 'toolbar.supportPanel.header' | translate }}</p>
    </div>

    <a id="support-hub-link" [href]="supportHubUrl" target="_blank" autofocus aria-label="Go to Support Hub">
        <div class="item-container">
            <div class="btn-icon" id="support-hub-icon">
                <i class="fa-light fa-circle-question"></i>
            </div>
            <label for="support-hub-icon" id="support-hub-label">{{ 'supportMenu.supportHub' | translate }}</label>
        </div>
        <i class="fa-regular fa-arrow-up-right-from-square"></i>
    </a>
    <a id="phone" href="tel:1-888-321-2113" aria-label="Call 1-888-321-2113">
        <div class="item-container">
            <div class="btn-icon" id="phone-icon">
                <i class="fa-light fa-phone"></i>
            </div>
            <label for="phone-icon" id="phone-label">1-888-321-2113</label>
        </div>
    </a>
    <a id="email" href="mailto:help@transnetyx.com" aria-label="Mail to Transnetyx">
        <div class="item-container">
            <div class="btn-icon" id="email-icon">
                <i class="fa-light fa-envelope"></i>
            </div>
            <label for="email-icon" id="email-label">{{ 'Help@transnetyx.com' }}</label>
        </div>
    </a>
    <a id="terms-of-use-link" [href]="termsOfUseUrl" target="_blank" aria-label="Open Terms of use">
        <div class="item-container">
            <div class="btn-icon" id="terms-of-use-icon">
                <i class="fa-light fa-file-contract"></i>
            </div>
            <label for="terms-of-use-icon" id="terms-of-use-label">{{ 'supportMenu.termsOfUse' | translate }}</label>
        </div>
        <i class="fa-regular fa-arrow-up-right-from-square"></i>
    </a>
</nav>
